<template>
	<a
		class="kook-btn"
		:href="url"
		:target="blank ? '_blank' : ''"
		:class="isLink ? '--clickable' : '--not-clickable'"
		v-html="texte"
	></a>
</template>

<script>
/**
 * Composant permettant d'afficher un bouton
 */
export default {
	name: 'KookBtn',
	props: {
		/**
		 * Le texte du bouton
		 */
		texte: {
			type: String,
		},
		/**
		 * Le lien du bouton
		 */
		url: {
			type: String,
			default: '#',
		},
		/**
		 * lien clicable ou pas ? (utile quand bouton englobé dans une balise a)
		 */
		isLink: {
			type: Boolean,
			default: true,
		},
		/**
		 * lien en target _blank ?
		 */
		blank: {
			type: Boolean,
			default: false,
		},
	},
};
</script>

<style lang="scss">
.kook-btn strong {
	margin-left: 5px;
}
</style>

<style lang="scss" scoped>
@import '~@scss/_vars.scss';

@mixin btnColors($bg, $font, $border: $bg, $isBgTransparent: 'false') {
	border-color: $border;
	background-color: $bg;
	color: $font;
	box-shadow: none;
	cursor: pointer;

	&.inverted {
		border-color: $border;
		@if $isBgTransparent == 'false' {
			background-color: $font;
			color: $bg;
		} @else {
			background-color: white;
			@if $font != white {
				color: $font;
			} @else {
				color: $mainColor;
			}
		}
	}

	&:hover {
		border-color: $border;
		@if $isBgTransparent == 'false' {
			background-color: $font;
			color: $bg;
		} @else {
			// Quand on a un bg transparent de base, au hover (ou en inverted vu que c'est pareil)
			// Le fond devient blanc et la font devient soit blanche
			// soit prend la couleur principale du site si la font était blanche de base
			background-color: white;
			@if $font != white {
				color: $font;
			} @else {
				color: $mainColor;
			}
		}

		&.inverted {
			border-color: $border;
			background-color: $bg;
			color: $font;
		}

		> i.fa:after {
			background-color: $bg;

			&.inverted {
				background-color: $font;
			}
		}
	}
}

.kook-btn {
	position: relative;
	display: inline-flex;
	justify-content: center;
	align-items: center;
	min-height: 45px;
	height: 45px;
	padding: 17px 20px;
	white-space: nowrap;
	font-family: $mainFont;
	font-weight: bold;
	font-size: 15px;
	line-height: 1;
	text-decoration: none;
	border: 2px solid transparent;
	border-radius: 50px;
	cursor: pointer;
	color: white;
	background-color: $secondaryColor;
	outline: none;
	transition: all 0.3s ease-in-out;

	&:hover {
		@media screen and (min-width: $break-tablet + 1) {
			background-color: $mainColor;
		}

		.plus {
			margin-top: 2px;
			transform: rotateZ(135deg);
		}
	}

	&.--bg-white {
		@include btnColors(white, $mainColor, white, 'false');

		&.--font-orange {
			@include btnColors(white, $secondaryColor, white, 'false');
		}

		&.--font-gris {
			@include btnColors(white, $gris, white, 'false');
		}
	}

	&.--word-wrap {
		white-space: normal;
	}

	&.--bg-transparent {
		@include btnColors(transparent, $mainColor, $secondaryColor, 'true');
	}

	&.--angle-left {
		padding-left: 50px;

		&:after {
			content: '\f105';
			font-family: FontAwesome;
			position: absolute;
			top: 50%;
			left: 25px;
			transform: translateY(-50%) rotate(180deg);
			transform-origin: center;
			font-size: 22px;
			font-weight: 200;
		}
	}

	&.--angle-right {
		padding-right: 50px;

		&:after {
			content: '\f105';
			font-family: FontAwesome;
			position: absolute;
			top: 50%;
			right: 25px;
			transform: translateY(-50%);
			font-size: 22px;
			font-weight: 200;
		}
	}

	&.--not-bold {
		font-weight: normal;
	}

	&.--not-clickable {
		pointer-events: none;
	}
}
</style>


// WEBPACK FOOTER //
// src/components/global/KookBtn.vue